var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import numeral from 'numeral';
import { format, parseISO } from 'date-fns';
export function safeSummary(data) {
    var _a;
    return (((_a = data === null || data === void 0 ? void 0 : data.organization) === null || _a === void 0 ? void 0 : _a.safeTerms.map(function (safeTerm) {
        var raised = safeTerm.safes.reduce(function (acc, safe) {
            return acc + (safe.state === 'ISSUED' ? safe.principal : 0);
        }, 0);
        return {
            id: safeTerm.id,
            name: safeTerm.name,
            cap: safeTerm.valuationCap,
            discount: safeTerm.discount,
            raised: raised,
        };
    })) || []);
}
export function noteSummary(data) {
    var _a;
    return (((_a = data === null || data === void 0 ? void 0 : data.organization) === null || _a === void 0 ? void 0 : _a.debtTerms.map(function (debtTerm) {
        var raised = debtTerm.debtNotes.reduce(function (acc, debtNote) {
            return acc + (debtNote.state === 'ISSUED' ? debtNote.principal : 0);
        }, 0);
        return {
            id: debtTerm.id,
            name: debtTerm.name,
            cap: debtTerm.valuationCap,
            discount: debtTerm.discount,
            interest: debtTerm.interest,
            raised: raised,
        };
    })) || []);
}
export function optionSummary(data) {
    var _a;
    return (((_a = data === null || data === void 0 ? void 0 : data.organization) === null || _a === void 0 ? void 0 : _a.optionPlans.map(function (optionPlan) {
        return {
            id: optionPlan.id,
            name: optionPlan.name,
            planSize: optionPlan.planSize,
            issuedOptions: optionPlan.issuedOptions,
            shareClassName: optionPlan.shareClass.name,
        };
    })) || []);
}
export function raisedOnShares(data) {
    var _a;
    return (((_a = data === null || data === void 0 ? void 0 : data.organization) === null || _a === void 0 ? void 0 : _a.shareClasses.reduce(function (acc, shareClass) {
        var raised = shareClass.shareCertificates.reduce(function (acc2, shareCertificate) {
            return (acc2 +
                (shareCertificate.state === 'ISSUED'
                    ? shareCertificate.amountPaid
                    : 0));
        }, 0);
        return acc + raised;
    }, 0)) || 0);
}
/**
 * Returns the sum of all outstanding convertibles and SAFEs
 */
export function totalOutstandingConvertibles(data) {
    var raisedOnSafes = safeSummary(data).reduce(function (acc, safe) {
        return acc + safe.raised;
    }, 0);
    var raisedOnNotes = noteSummary(data).reduce(function (acc, val) {
        return acc + val.raised;
    }, 0);
    return raisedOnSafes + raisedOnNotes;
}
/**
 * Returns the next upcoming note maturity date
 */
export function nextMaturityDate(data) {
    var _a;
    var maturityDate = (_a = data === null || data === void 0 ? void 0 : data.organization) === null || _a === void 0 ? void 0 : _a.debtTerms.map(function (e) { return e.maturityDate; }).reduce(function (acc, val) {
        return !acc || val < acc ? val : acc;
    }, '');
    if (!maturityDate) {
        return '-';
    }
    return format(parseISO(maturityDate), 'MMM d, yyyy');
}
/**
 * Returns the sum of all outstanding convertibles, SAFEs and money raised in
 * priced rounds (shares)
 */
export function totalRaised(data) {
    return totalOutstandingConvertibles(data) + raisedOnShares(data);
}
export function formatCurrency(amount) {
    return numeral(amount).format('($0,0a)').toUpperCase();
}
export function mapCapTableProps(data) {
    var _a, _b, _c;
    var capTableData = {
        securities: __spreadArrays((((_a = data === null || data === void 0 ? void 0 : data.organization) === null || _a === void 0 ? void 0 : _a.shareClasses.reduce(function (acc, shareClass) {
            var issuedSecurities = shareClass.shareCertificates
                .filter(function (shareCertificate) { return shareCertificate.state === 'ISSUED'; })
                .map(function (shareCertificate) { return ({
                id: shareCertificate.id,
                quantity: shareCertificate.quantity,
                stakeholder: {
                    id: shareCertificate.holder.id,
                    name: shareCertificate.holder.name || '---',
                },
                shareClass: {
                    id: shareClass.id,
                    name: shareClass.name,
                },
            }); });
            return __spreadArrays(acc, issuedSecurities);
        }, [])) || []), (((_b = data === null || data === void 0 ? void 0 : data.organization) === null || _b === void 0 ? void 0 : _b.optionPlans.reduce(function (acc, optionPlan) {
            var issuedSecurities = optionPlan.optionGrants
                .filter(function (optionGrant) { return optionGrant.state === 'ISSUED'; })
                .map(function (optionGrant) { return ({
                id: optionGrant.id,
                quantity: optionGrant.quantity,
                stakeholder: {
                    id: optionGrant.holder.id,
                    name: optionGrant.holder.name || '---',
                },
                optionPlan: {
                    id: optionPlan.id,
                    name: optionPlan.name,
                    planSize: optionPlan.planSize,
                },
            }); });
            return __spreadArrays(acc, issuedSecurities);
        }, [])) || [])),
        optionPlans: ((_c = data === null || data === void 0 ? void 0 : data.organization) === null || _c === void 0 ? void 0 : _c.optionPlans.map(function (optionPlan) { return ({
            id: optionPlan.id,
            name: optionPlan.name,
            planSize: optionPlan.planSize,
        }); })) || [],
    };
    return capTableData;
}
//# sourceMappingURL=cap-table-helpers.js.map